import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { config } from '../../../config';
import { HeaderBar } from './HeaderBar';
import { HeaderNav } from './HeaderNav';
import { PreviousBookingLoginModal } from './PreviousBookingLoginModal';

export const Header = () => {
  const location = useLocation();
  const [menuData, setMenuData] = useState();
  const menuJSON = `/json-files/${config['header.megaMenu']}`;
  const [showPreviousBookingForm, setShowPreviousBookingForm] = useState(false);
  const hasNoMenuData = !menuData || Object.keys(menuData)?.length === 0;

  const isInBookingJourney = location.pathname.includes('/booking/');

  useEffect(() => {
    // Fetch menu json
    const controller = new AbortController();
    fetch(menuJSON, { signal: controller.signal })
      .then((response) => response.json())
      .then((data) => {
        setMenuData(data);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('Error: ' + err.message);
        }
      });
    return () => controller.abort();
  }, [menuJSON]);

  if (hasNoMenuData) return null;

  return (
    <>
      {showPreviousBookingForm && (
        <PreviousBookingLoginModal show={showPreviousBookingForm} onClose={() => setShowPreviousBookingForm(false)} />
      )}

      <HeaderBar openMyBookingModal={() => setShowPreviousBookingForm(true)} />
      {!isInBookingJourney && (
        <HeaderNav menuData={menuData} openMyBookingModal={() => setShowPreviousBookingForm(true)} />
      )}
    </>
  );
};
